export default "__VITE_ASSET__CcrM7JZz__"